import script from "./buybox-bundle-generic.vue?vue&type=script&setup=true&lang=js"
export * from "./buybox-bundle-generic.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__